// extracted by mini-css-extract-plugin
export default {"contentWrapperTopPadding":"6em","mediumGrey":"#777","ProjectScreenHeaderHeight":"60px","defaultFontFamily":"\"Roboto\",Arial,sans-serif","ControlGroup":"styles_ControlGroup__WWhho"};